import $ from 'jquery';

const SCROLLED = 'scrolled';
const header = () => {
  const $header = $('.c-header');
  const $win = $(window);

  if ($header.length) {
    $win.scroll(() => {
      if ($win.scrollTop() > 100) {
        $header.addClass(SCROLLED);
      } else {
        $header.removeClass(SCROLLED);
      }
    });
  }

  const requestClose = $('.c-header__request-mobile-close');
  const $body = $('body');
  if (requestClose.length) {
    requestClose.click(ev => {
      ev.preventDefault();
      $body.addClass('hide-request-mobile');
    });
  }
};
export default header;



// WEBPACK FOOTER //
// ./src/scripts/modules/header.js